import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../services/authService';
import './Header.css';

const Header = ({ onAdminClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    setAuthenticated(isAuthenticated());
    
    // Escuchar cambios en localStorage para actualizar estado de autenticación
    const handleStorageChange = () => {
      setAuthenticated(isAuthenticated());
    };
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleAdminClick = (e) => {
    e.preventDefault();
    if (onAdminClick) {
      onAdminClick();
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <img src="/images/logo-light.png" alt="Logo light" className="logo-light" />
          <img src="/images/logo-dark.png" alt="Logo oscuro" className="logo-dark" />
        </div>
        <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <a href="#inicio" onClick={(e) => { e.preventDefault(); scrollToSection('inicio'); }}>
            Inicio
          </a>
          <a href="#servicios" onClick={(e) => { e.preventDefault(); scrollToSection('servicios'); }}>
            Servicios
          </a>
          <a href="#nosotros" onClick={(e) => { e.preventDefault(); scrollToSection('nosotros'); }}>
            Nosotros
          </a>
          <a href="#galeria" onClick={(e) => { e.preventDefault(); scrollToSection('galeria'); }}>
            Galería
          </a>
          <a href="#contacto" onClick={(e) => { e.preventDefault(); scrollToSection('contacto'); }}>
            Contacto
          </a>
          
            <a href="#admin" onClick={handleAdminClick}>
              Iniciar sesión
            </a>
          
        </nav>
        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
